import { FormControl, FormGroup } from "@angular/forms";

export type LandAreaFormGroup = FormGroup<{
  planning_status_id: FormControl<number>,
  qos_degradation_id: FormControl<number>,
  env_considerations: FormControl<string>,
  other_considerations: FormControl<string>
}>

export function createLandAreaFormGroup(payload: {
  planningStatusId: number,
  qosDegradationId: number,
  envConsiderations: string,
  otherConsiderations: string
}): LandAreaFormGroup {
  return new FormGroup({
    planning_status_id: new FormControl<number>(payload.planningStatusId),
    qos_degradation_id: new FormControl<number>(payload.qosDegradationId),
    env_considerations: new FormControl<string>(payload.envConsiderations),
    other_considerations: new FormControl<string>(payload.otherConsiderations)
  })
}